export default "__VITE_ASSET__CsTxICAk__"